var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarCameraLinear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27668 11.7628C10.4211 11.7628 11.3488 10.8351 11.3488 9.69068C11.3488 8.5463 10.4211 7.61859 9.27668 7.61859C8.1323 7.61859 7.20459 8.5463 7.20459 9.69068C7.20459 10.8351 8.1323 11.7628 9.27668 11.7628Z",
    stroke: "black",
    strokeWidth: 0.92093
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74188 15.2163H10.8113C12.967 15.2163 14.0452 15.2163 14.8195 14.7086C15.1535 14.4897 15.4413 14.2071 15.6662 13.877C16.1836 13.1173 16.1836 12.0584 16.1836 9.94211C16.1836 7.82513 16.1836 6.76698 15.6662 6.00721C15.4413 5.67713 15.1536 5.39456 14.8195 5.17561C14.3222 4.84891 13.6991 4.73218 12.7453 4.69074C12.2901 4.69074 11.8985 4.3523 11.8094 3.91371C11.7413 3.59244 11.5644 3.30453 11.3085 3.09865C11.0527 2.89276 10.7336 2.78152 10.4052 2.78372H8.14801C7.4656 2.78372 6.87781 3.25685 6.74382 3.91371C6.65472 4.3523 6.26309 4.69074 5.80792 4.69074C4.85476 4.73218 4.23175 4.8496 3.73376 5.17561C3.39989 5.3946 3.11239 5.67718 2.88765 6.00721C2.36963 6.76698 2.36963 7.82513 2.36963 9.94211C2.36963 12.0584 2.36963 13.1166 2.88696 13.877C3.11075 14.2058 3.39808 14.4883 3.73376 14.7086C4.50803 15.2163 5.58621 15.2163 7.74188 15.2163Z",
    stroke: "black",
    strokeWidth: 0.92093
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1116 7.61859H13.4209",
    stroke: "black",
    strokeWidth: 0.92093,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarCameraLinear);
export default __webpack_public_path__ + "static/media/solar_camera-linear.b86e5eccb2f4d60be6471c1f0629f4f2.svg";
export { ForwardRef as ReactComponent };